<template>
    <v-row wrap class="bg my-0">
        <v-col cols="12" sm="4" md="3" lg="2" xl="2" class="my-0 py-0">
            <v-sheet v-if="researcher.photo " class="d-flex" fill-height>
                <v-img :src="researcher.photo" aspect-ratio="0.75" class="grey lighten-2" max-height="400">
                </v-img>
            </v-sheet>
            <div class="mt-2 mb-1 white--text">
                <span class="text-h5 font-weight-normal mt-2" v-html="researcher.first_name"> </span>
                <span class="text-h5 font-weight-bold ml-1 mt-2" v-html="researcher.last_name"></span>
                <p class="my-0 pa-0 text-subtitle-1">{{researcher.title}}</p>
            </div>
            <app-researcher-basics v-if="!xsOnly" :researcher="researcher"></app-researcher-basics>
        </v-col>
        <v-col v-if="!xsOnly" cols="12" sm="8" md="9" lg="9" xl="9" class="my-0 py-0">
            <app-researcher-quotes v-if="infos.quotes" :quotes="infos.quotes" class="mt-0 ml-3"></app-researcher-quotes>
            <app-researcher-department-interest class="ml-3" :researcher="researcher" :interests="infos.interests"
                :cv="infos.cv" :homepage="infos.homepage">
            </app-researcher-department-interest>
            <v-spacer></v-spacer>
        </v-col>
        <app-researcher-department-interest v-if="xsOnly" :researcher="researcher" :interests="infos.interests"
            :cv="infos.cv" :homepage="infos.homepage">
        </app-researcher-department-interest>
        <v-col cols="12" xl="12" class="mt-1">
            <app-scientific-production v-if="isProduction" :id="id" :hasPublications="hasPublications"
                :hasGrants="hasGrants" :hasLectures = "hasLectures">
            </app-scientific-production>
        </v-col>
    </v-row>
</template>
<script>
import scientificProduction from '../scientificProduction/ScientificProduction.vue';
import researcherQuotes from './ResearcherQutes.vue';
import ResearcherDepartmentInterest from './ResearcherDepartmentInterest.vue';
import researcherBasics from './ResearcherBasics.vue';
import { mapActions, mapGetters } from 'vuex';

function updateData(baseline, updates) {
    return Object.fromEntries(
        Object.entries(baseline).map(([key, val]) => [key, key in updates ? updates[key] : val])
    )
}

const supervisorCategory = 1;

export default {
    props: ['item'],
    metaInfo() {
        return{
            title: this.researcher.first_name+' '+this.researcher.last_name
        }
    },
    data() {
        return {
            id: 0,
            researcher: {
                id: 0,
                category_id: 1,
                email: "",
                last_name: "",
                first_name: "",
                title: "",
                telephone: "",
                office:null,
                photo: "",
                department_id: 0,
                from_grant: null,
            },
            infos: {
                quotes: {},
                interests: [],
                cv: null,
                homepage:null,
            },
            isProduction: false,
            hasGrants: false,
            hasPublications: false,
            hasLectures: false,
        }
    },
    created() {
        if (this.item) {
            this.id = Number(this.item.id);
        } else {
            this.id = Number(this.$route.params.id);
        }
        this.allDataLoaders = Promise.all([
            this.getResearcher(),
            this.getResearcherInfos(),
            this.getProduction(),
            this.retrieveDepartments(),
            this.retrieveResearchers({ category: supervisorCategory })
        ]);

        // signalDataUpdate will await the promise before doing anything.
        this.signalDataUpdate();
    },
    computed: {
        ...mapGetters('header', {
            language: 'language',
            mdAndDown: 'mdAndDown',
            xsOnly: 'xsOnly'
        }),
        ...mapGetters('researcher', ['getDepartments', 'getResearchers']),
    },
    methods: {
        ...mapActions('researcher', ['retrieveDepartments', 'retrieveResearchers']),
        async getResearcher() {
            try {
                const res = await axios.get('/index.php/api/member/' + this.id);
                if (res) {
                    this.researcher = res.data[0];
                }
            }
            catch (error) {
                throw error;
            }
        },
        async getResearcherInfos() {
            // TODO: maybe, to optimize, we could get this info
            // from the store.
            try {
                const result = await axios.get('/index.php/api/member/profilResearcherInfo/' + this.id);
                if (result) {
                    this.infos = result.data;
                }
            }
            catch (error) {
                throw error;
            }
        },
        async getProduction() {
            try {
                const result = await axios.get('/index.php/api/publications/authorHasPublications/' + this.id);
                if (result) {
                    this.hasPublications = result.data;
                }
            }
            catch (error) {
                throw error;
            };
            try {
                const res = await axios.get('/index.php/api/grants/memberHasGrants/' + this.id);
                if (res) {
                    this.hasGrants = res.data;
                }
            }
            catch (error) {
                throw error;
            }
            try {
                //Route::get('publications/authorHasLectures/{id}',[PublicationController::class,'getNbLecture']);

                const res = await axios.get('/index.php/api/publications/authorHasLectures/' + this.id);
                if (res) {
                    this.hasLectures = res.data;
                }
            }
            catch (error) {
                throw error;
            }
            if (this.hasPublications || this.hasGrants || this.hasLectures)
                this.isProduction = true;
        },
        pushSupervisor(field) {
            if (field in this.item.doc_profile) {
                let supervisorKey = this.item.doc_profile[field];
                if (this.getResearchers(supervisorCategory).has(supervisorKey)) {
                    let supervisor = this.getResearchers(supervisorCategory).get(supervisorKey);
                    this.researcher.supervisors.push(supervisor);
                }
            }
        },
        async signalDataUpdate() {
            // Make sure all the needed data has been retrieved.
            await this.allDataLoaders;
            if (this.item) {
                // Update all possible fields of researcher
                // from data in 'item' but leave all fields
                // of researcher which are not present in item
                // unchanged.
                this.researcher = updateData(this.researcher, this.item);
                this.researcher = updateData(this.researcher, this.item.researcher_profile);
                if (this.item.doc_profile) {
                    this.researcher.supervisors = [];
                    this.pushSupervisor('supervisor_id');
                    this.pushSupervisor('supervisor1_id');
                    this.pushSupervisor('supervisor2_id');
                    this.researcher.university = {
                        name : this.item.doc_profile.funding,
                        url : this.item.doc_profile.url_funding
                    }
                }

                // Make sure the name is still right.
                this.researcher.departmentName = this.getDepartments.get(this.researcher.department_id).name;
                // Same for infos.
                this.infos = updateData(this.infos, this.item);
                this.infos = updateData(this.infos, this.item.researcher_profile);
            }
        }
    },
    components: {
        'AppScientificProduction': scientificProduction,
        'AppResearcherQuotes': researcherQuotes,
        'AppResearcherDepartmentInterest': ResearcherDepartmentInterest,
        'AppResearcherBasics': researcherBasics,
    }
}

</script>

<style>
.bg {
    /* The image used */
    background-image:
        /*linear-gradient(rgba(43, 41, 41, 0.5), rgba(16, 9, 36, 0.5)),*/
        url("../../../assets/members/mural.jpg");
    background-repeat: repeat-y;
    /* Full height */
    /* height: 100%; */
    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.transparent {
    background-color: transparent !important;
    border-color: transparent !important;
}

.v-sheet {
    display: block;
    border-radius: 2px;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
}
</style>
